import React, { useState } from 'react';
import axios from 'axios';

const Withdraw = ({ t }) => {
  const [amount, setAmount] = useState('');
  const [method, setMethod] = useState(1); // 1 for crypto, 2 for fiat
  const [status, setStatus] = useState(1); // 1 for succeed, 2 for pending
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage(''); // Clear previous error message

    const data = {
      amount,
      method,
      status,
    };

    const accessToken = localStorage.getItem('accessToken');

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/account/withdraw`,
        data,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        alert('Withdrawal Successful!');
      }
    } catch (err) {
      // Check if the error has a response and then extract the message
      if (err.response && err.response.data && err.response.data.message) {
        setErrorMessage(err.response.data.message); // Show the error message
      } else {
        setErrorMessage('An unknown error occurred. Please try again.'); // Fallback message if no specific error is returned
      }
    } finally {
      setLoading(false);
    }
};

  return (
    <div className="max-w-md mx-auto p-4 bg-white rounded-lg shadow-lg">
      <h2 className="text-2xl font-semibold text-center mb-4">Withdraw Funds</h2>
      {errorMessage && <div className="text-red-500 text-sm mb-2">{errorMessage}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="amount" className="block text-sm font-medium">Amount</label>
          <input
            type="number"
            id="amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            required
            className="mt-1 block w-full p-2 border rounded-md shadow-sm"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="method" className="block text-sm font-medium">Method</label>
          <select
            id="method"
            value={method}
            onChange={(e) => setMethod(e.target.value)}
            className="mt-1 block w-full p-2 border rounded-md shadow-sm"
          >
            <option value={1}>Crypto Agent</option>
            <option value={2}>Fiat Agent</option>
          </select>
        </div>
        <div className="mb-4">
          <label htmlFor="status" className="block text-sm font-medium">Status</label>
          <select
            id="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="mt-1 block w-full p-2 border rounded-md shadow-sm"
          >
            <option value={1}>Succeed</option>
            <option value={2}>Pending</option>
          </select>
        </div>
        <div className="flex justify-center">
          <button
            type="submit"
            disabled={loading}
            className={`px-6 py-2 mt-4 text-white bg-rose-500 rounded-md ${loading ? 'opacity-50' : ''}`}
          >
            {loading ? 'Processing...' : 'Withdraw'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default Withdraw;
